import * as stylex from "@stylexjs/stylex";
import React from "react";
import { colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
const RadioSelectBox = ({ title, options, selected, onChange })=>{
    const id = React.useId();
    const handler = (event)=>{
        onChange(event.target.value);
    };
    return <>
      <h4 {...stylex.props(typography.heading4, styles.title)}>{title}</h4>
      <div {...stylex.props(typography.table, styles.group)}>
        <div>
          {options.map(({ value, label: label1 })=>{
        const isSelected = value === selected;
        return <div key={value} className="xh8yej3 x78zum5 x6s0dn4 x12oqio5 xdqdrvq x268jtm">
                <input type="radio" id={`radio-${value}`} value={value} checked={isSelected} name={id} onChange={handler}/>
                <label htmlFor={`radio-${value}`} {...{
            0: {
                className: "xh8yej3 xet2fuk x1db2dqx xjvpvmj"
            },
            1: {
                className: "xh8yej3 xet2fuk x1db2dqx x12klvby"
            }
        }[!!isSelected << 0]}>
                  {label1}
                </label>
              </div>;
    })}
        </div>
      </div>
    </>;
};
export default RadioSelectBox;
const styles = {
    title: {
        k1K539: "x12nagc",
        $$css: true
    },
    group: {
        kWkggS: "x1n3tk9q",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x5snjlz",
        kaIpWk: "x12oqio5",
        k1K539: "x1yztbdb",
        $$css: true
    }
};
